// import { CircularProgress, Typography, Box } from "@mui/material";
import React, { Suspense } from "react";
import ContentRoutes from "./ContentRoutes";
import { styled } from "@mui/system";
import AuthContentRoutes from "./AuthContentRoutes";
import PageLoadingIndicator from "components/widgets/PageLoadingIndicator";

const ContentWrapper = styled("div")(() => ({
  // border:'1px solid black',
  //minHeight: '100vh'
}));

const Content = () => {
  return (
    <Suspense fallback={<PageLoadingIndicator />}>
      <ContentWrapper>
        <ContentRoutes />
        <AuthContentRoutes />
      </ContentWrapper>
    </Suspense>
  );
};

export default Content;
